<template>
<div>
	<div v-if="!$store.state.is_auth" class="text-center logo">
		<img :src="stylePathToLogo || '/static/img/logo/logo.png'" />
		<br><br>
	</div>

	<notFoundPage v-if="errorCode === 404" />

	<div v-else-if="errorCode === 403" class="alert alert-danger text-center error-block" role="alert">
		<div style="padding:0;margin:0;">{{ 'main/access_denied' | ftc }}</div>
	</div>

	<div v-else class="alert alert-danger text-center error-block" :class="{ 'outer': !$store.state.is_auth }" role="alert">
		<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(Text)"></span>
	</div>
</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import notFoundPage from '@/components/notFound'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'error500',
	//=========================================================================
	// данные переданные родителем
	//=========================================================================
	props: ['response'],
	//=========================================================================
	// данные
	//=========================================================================
	data() {
		return {
			errorCode: 0
		}
	},
	//=========================================================================
	// вычисляемые данные
	//=========================================================================
	computed: {
		Text() {
			if (this.errorCode === 400) return 'error/cookie'

			let _txt
			_txt = this.formatRequestError(this.response)
			if (_txt === undefined || _txt === null || String(_txt).trim() === '' || _txt === 'error/http_error')
				_txt = 'При выполнении запроса возникла ошибка.<br>Пожалуйста, обратитесь в службу технической поддержки.'
			return _txt
		}
	},
	//=========================================================================
	// создание
	//=========================================================================
	created() {
		// запомним текущий код
		let _code = this.$store.state.errorHttpCode
		// сразу сбросим код ошибки в хранилище
		this.$store.commit('errorHttpCode', 0)

		// если задали данные для ошибки или код ошибки
		if (this.response || _code)
		{
			// запоминаем код
			this.errorCode = _code > 0 ? _code : this.response.status
		}
		else
		{
			// это значит пришли по прямой ссылке - делаем редирект на главную
			this.$router.push('/')
		}
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		notFoundPage
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.error-block {
	margin: 20px auto;
	width: 100%;
}

.error-block.outer {
	width: 600px;
}
@media screen and (max-width: 767px) {
	.error-block {
		width: 300px;
	}
	.error-block.outer {
		width: 300px;
	}
}

</style>



// WEBPACK FOOTER //
// error500.vue?41ce7e74